<template>
  <modal-container :id="'createProjectModal'">
    <form @submit.prevent="submit">
      <div class="modal-header">
        <h5 class="modal-title">Create New Project</h5>
      </div>
      <div class="modal-body">
        <base-field label="Name">
          <base-input v-model="payload.name" placeholder="name" required />
        </base-field>
        <base-field v-if="$auth.admin()" label="Borrower">
          <base-select v-model="payload.user" :model="borrowers" model-text="email" placeholder="borrower" required />
        </base-field>
      </div>
      <div class="modal-footer">
        <base-button icon-right="arrow-right" :loading="saving" primary submit>
          Create
        </base-button>
      </div>
    </form>
  </modal-container>
</template>

<script>
import { mapGetters, mapState } from 'vuex'

import ModalContainer from './ModalContainer.vue'

export default {
  created () {
    if (this.$auth.admin()) {
      this.$store.dispatch('core/users/borrowers')
    }
  },

  mounted () {
    this.$modal.shown('#createProjectModal', function () {
      $(this).find('input').first().focus()
    })

    this.payload = this.$_.cloneDeep(this.schema)

    if (!this.$auth.admin()) this.payload.user = this.$auth.user._id
  },

  data () {
    return {
      payload: {},
      saving: false
    }
  },

  name: 'CreateProjectModal',

  components: {
    ModalContainer
  },

  computed: {
    ...mapGetters({
      schema: 'core/projects/schema'
    }),

    ...mapState({
      borrowers: store => store.core.users.borrowers,
      project: store => store.core.projects.entity
    })
  },

  methods: {
    async submit () {
      this.saving = true

      await this.$store.dispatch('core/projects/save', this.payload)

      this.$modal.close('#createProjectModal')

      this.$flash.success('New project successfully created.')

      this.$router.push({ name: 'projects.dashboard', params: { id: this.project._id } })
    }
  }
}
</script>
